package horcrux.frontend.common.views.components.containers

import kotlinx.serialization.Serializable
import mui.material.Alert
import mui.material.AlertColor
import mui.material.Snackbar
import mui.system.sx
import react.FC
import react.Props
import web.cssom.pct
import web.timers.setTimeout
import kotlin.time.Duration.Companion.seconds

@Serializable
enum class Severity {
    SUCCESS,
    INFO,
    WARNING,
    ERROR;

    companion object {
        fun fromAlertColor(alertColor: AlertColor): Severity =
            when (alertColor) {
                AlertColor.success -> SUCCESS
                AlertColor.info -> INFO
                AlertColor.warning -> WARNING
                AlertColor.error -> ERROR
                else -> error("invalid alertColor $alertColor")
            }
    }
}

val Severity.alertColor: AlertColor
    get() =
        when (this) {
            Severity.SUCCESS -> AlertColor.success
            Severity.INFO -> AlertColor.info
            Severity.WARNING -> AlertColor.warning
            Severity.ERROR -> AlertColor.error
        }

@Serializable
data class AlertBannerData(var severity: Severity, var messageMaybe: String?)


external interface AlertBannerProps : Props {
    var alertBannerData: AlertBannerData
    var timeoutOperation: () -> Unit
}

val AlertBanner = FC<AlertBannerProps> { props ->
    props.alertBannerData.messageMaybe?.let { message ->
        Snackbar {
            this.open = true
            Alert {
                sx {
                    this.width = 100.pct
                }
                this.severity = props.alertBannerData.severity.alertColor.toString()
                setTimeout(5.seconds) {
                    props.timeoutOperation()
                }
                +message
            }
        }
    }
}

typealias UpdateBanner = (AlertColor, String) -> Unit
